import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Bookings from './pages/Bookings';
import toast, { Toaster } from 'react-hot-toast';
import { generateToken, messaging } from './notifications/firebase';
import { useEffect } from 'react';
import { onMessage } from 'firebase/messaging';

function App() {
  useEffect(() => {
    generateToken();
    onMessage(messaging, (payload) => {
      console.log(payload);
      toast(payload.notification.body);
    })
  }, []);

  return (
    <BrowserRouter>
     <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/bookings" element={<Bookings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;


